import { useProcessModular } from "../../../pages/ProcessModular/useProcessModular";
import { getAxiosClient } from "../../../services/HttpsService";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { ProcessModelParams } from "./processModular-interface";
import { ProcessVariable } from "./ProcessVaraible-interface";

export const saveProcessDefination = createAsyncThunk(
  "processModular/openProcessDefination",
  async () => {
    console.log("saveProcessDefination");
    const isInstanceBased = false;
    const { onSaveToDB } = useProcessModular({ isInstanceBased });
    onSaveToDB();
    return;
  }
);

export const fetchProcessModels = createAsyncThunk(
  "processModel/fetchProcessModel",
  async (processModelId: string | undefined) => {
    const client = getAxiosClient();
    const response = await client.get(`/main/processModel/${processModelId}`);
    return response.data as ProcessModelParams;
  }
);

export const fetchProcessModelJson = createAsyncThunk(
  "processModel/fetchProcessModelJson",
  async (processModelId: string | undefined) => {
    const client = getAxiosClient();
    const response = await client.get(
      `/api/eza_app_process_json_map/process/${processModelId}`
    );
    return response.data;
  }
);

export const fetchProcessVaraiblesbyProcessId = createAsyncThunk(
  "processModel/fetchProcessVaraiblesbyProcessId",
  async (processModelId: string | undefined) => {
    const client = getAxiosClient();
    const response = await client.get(
      `/api/eza_app_process_var/process/${processModelId}`
    );
    return response.data as ProcessVariable[];
  }
);

// export const fetchProcessVaraiblesbyProcessIdsList = createAsyncThunk(
//   "processModel/fetchProcessVaraiblesbyProcessId",
//   async (processModelIdsList: string[] | undefined) => {
//     const client = getAxiosClient();
//     const response = await client.get(
//       `/api/eza_app_process_var/process/${processModelId}`
//     );
//     return response.data as ProcessVariable[];
//   }
// );
